import React from "react";
import ReactDOM from "react-dom/client";
// driver.js precisa ser importado ANTES de index.css: o override do tema
// escuro do tour (.driver-popover etc.) vive em index.css, e como CSS
// resolve empate de especificidade pela ordem de inserção no bundle, se
// driver.css entrasse depois (como acontecia quando só era importado
// dentro de App.js) ele vencia e o popover do tour voltava a ficar claro.
import "driver.js/dist/driver.css";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
